import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Api } from '../../services/api';

@Component({
  selector: 'app-course-main-evolvingteaching',
  standalone: false,
  templateUrl: './course-main-evolvingteaching.html',
  styleUrl: './course-main-evolvingteaching.scss'
})
export class CourseMainEvolvingteaching {
       videoMap: {[key: string]: string} = {
    'intro1': 'kpy6QEAuLJw', 
    'intro2': 'abcdefghijk',
    'chatgpt1': 'xyz12345678'
  };
  expandedSections: boolean[] = [false, false, false, false, false];
  showVideoModal = false;
  currentVideo: string | null = null;
  allExpanded = false;
  constructor(private sanitizer: DomSanitizer,private apiservices:Api) {}

  toggleSection(index: number): void {
    this.expandedSections[index] = !this.expandedSections[index];
  }

  expandAll(): void {
  this.allExpanded = !this.allExpanded;
  this.expandedSections = this.expandedSections.map(() => this.allExpanded);
}


  closeVideo(): void {
    this.showVideoModal = false;
    this.currentVideo = null;
  }

getSafeVideoUrl(videoKey: string | null): SafeResourceUrl {
    if (!videoKey || !this.videoMap[videoKey]) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    
    const videoId = this.videoMap[videoKey];
    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}?` + 
      `autoplay=1&` +
      `rel=0&` +
      `modestbranding=1&` +
      `enablejsapi=1`;
      
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  playVideo(videoKey: string): void {
    this.currentVideo = videoKey;
    this.showVideoModal = true;
  }
  joinMeeting() {
     window.open('https://meet.google.com/eor-oyhw-emi', '_blank');
  }

}
